import http from '@/utils/http'; 
import { DBO_U } from '@op/utils/format';

export interface IFilter {
  [key: string]: Array<string>;
}

export interface IRequestData {
  filters?: IFilter;
  [key: string]: any;
}

export interface IRequestOptions {
  url: string;
  method: string;
  data?: IRequestData;
  [key: string]: any;
}

const request = (options: IRequestOptions) => {
  const map = DBO_U.query(window.location.href);
  const realOptions = { ...options };
  if (map.get('_refresh') === '1') {
    realOptions.headers = { 'Need-Cache': 0 };
  }

  return http(realOptions);
};

export default request;
